module.exports = __webpack_public_path__ + "static/media/bg_kc_1_sm.e65f6049.jpg";